import React from 'react';

interface LogoProps {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({
  className = '',
  iconClassName = 'h-14 sm:h-16',
  textClassName = '',
  showText = true,
}) => {
  const image = showText
    ? {
        src: '/blackbelts-logo@1x.png',
        srcSet: '/blackbelts-logo@1x.png 1x, /blackbelts-logo@2x.png 2x, /blackbelts-logo@3x.png 3x',
        width: 360,
        height: 120,
      }
    : {
        src: '/blackbelts-mark@1x.png',
        srcSet: '/blackbelts-mark@1x.png 1x, /blackbelts-mark@2x.png 2x, /blackbelts-mark@3x.png 3x',
        width: 120,
        height: 120,
      };

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={image.src}
        srcSet={image.srcSet}
        alt="BlackBelts.app"
        width={image.width}
        height={image.height}
        className={`w-auto object-contain drop-shadow-lg ${iconClassName} ${textClassName}`}
      />
    </div>
  );
};

export default Logo;
